export const m = {
  EnterID: "Clique para digitar o Tada ID",
  "select-specifications":
    "Clique para selecionar as especificações de recarga",
  "check-account": "Verifique a conta de recarga",
  whatID: "O que é o Tada ID?",
  getID: "Digite o Tada ID",
  maskgetID: "Digite o Tada ID",
  "toastTips-format-error": "Formato de entrada está incorreto",
  "toastTips-no-exist": "O ID não existe",
  toastTipsPlease: "Verifique a conta recarregada primeiro",
  "common-problem": "Problema comum",
  "transaction-succeeded": "Transação foi bem sucedida",
  "transaction-failed": "Falha na transação",
  "transaction-cancel": "Transação foi cancelada",
  "whether-account": "1.Depois de recarregar, como posso verificar se chegou?",
  "answer-whether-account":
    "Após a recarga, você pode voltar para [Meu] - [Carteira] do aplicativo para visualizar os diamantes.",
  "no-account": "2.Após a recarga, o que devo fazer se não chegar?",
  "answer-no-account":
    "Envie suas perguntas em [Mensagem] - [Notícias oficiais] - [Comentários e ajuda] do aplicativo e forneça as seguintes informações, nosso serviço ao cliente irá ajudá-lo.",
  "recharge-money": "1. Valor da recarga e ID da conta",
  "recharge-time": "2. Data e hora da recarga",
  "recharge-shot": '3. Captura de tela do pagamento bem-sucedido "',
  "recharge-wrong":
    "3.O que devo fazer se cobrar a conta errada e cobrar a quantia errada.",
  "answer-recharge-wrong":
    "Antes de inserir a senha de pagamento, por favor certifique-se de confirmar cuidadosamente o ID da conta de recarga e as informações sobre o valor da recarga antes de fazer uma compra.",
  refund: "4.Reembolso",
  "answer-refund":
    "Desculpe! O Tada atualmente não oferece suporte a nenhuma forma de reembolso.",
  "buy-enter-link":
    'Os diamantes de compra podem ser recarregados através do link <a class="web-link" href="https://pay.tadachat.info/" >https://pay.tadachat.info</a>, copie o link e abra-o no seu navegador móvel, vá para a página de compra, verifique o número da conta, selecione as especificações correspondentes e use o método de pagamento apropriado para pagar ~ muitos descontos!',
  "buy-notice-a":
    "Nota:<a>pay.tadachat.info</a> é o único site oficial de compra de diamantes do Tada.",
  replace: "Substituir",
  sureBtn: "OK",
  "pay-style": "Escolher método de pagamento",
  goBack: "Voltar a página inicial",
  toastTips: "Digite o Tada ID",
  rechargeFAQ_title: "Problema comum",
  PayStatusSuccess_title: "Transação foi bem sucedida",
  PayStatusFail_title: "Falha na transação",
  PayStatusCancel_title: "Transação foi cancelada",
  Diamonds_title: "Site oficial de recarga do diamante de Tada",
  "buy-notice":
    "Nota O pay.Tadachat.info é o único site oficial de compra de diamantes do Tada. Para consultas sobre atendimento ao cliente, digite [Mensagem] - [Notícias oficiais] - [Comentários e ajuda]",
  RechargeHelp_title: "Ajuda de recarregar",
  openAPP: "Open Tada APP",
  "buy-diamonds-tit": "Comprar serviços de diamantes",
  description:
    "Único site oficial de recarga de diamantes do Tada, o Tada é um software social internacional, usuários de mais de 150 países e regiões do mundo estão usando o Tada",
  keywords:
    "Recarga do Tada, recarga de diamante do Tada, recarga oficial do Tada, site oficial de recarga do Tada",
  payforType: "Método de recarga",
  trueText: "OK",
  falseText: "abolir",
  alertShowTxt1: "Tem certeza de que usará",
  alertShowTxt3: "para recarregar",
  alertShowTxt5: "diamantes?",

  EnterIDTip: "Recarga rápida Tada",

  scanLogin:
    "Para privacidade e segurança da conta, por favor, digitalize o código para fazer o login",
  scanTip:
    'Dica: Clique em Swipe" no canto superior direito do Tada "Personal Center/Data".',
  scanVersion:
    'Passe o código para fazer o login, e também suporte o reconhecimento da captura de tela do código QR para fazer o login"',
  delAccount: "Excluir conta",
  logout: "Sair",

  submit: "Enviar",
  email_place_holder: "Digite sua caixa postal",
  contact_email: "E-mail de contato",
  provide_email:
    "Favor fornecer seu endereço de e-mail para receber notificações de pagamento",
  email_address: "Endereço de e-mail",
};



// WEBPACK FOOTER //
// ./src/lang/pt.js